import { render, staticRenderFns } from "./ViewButtonBar.vue?vue&type=template&id=5883b576&scoped=true&"
import script from "./ViewButtonBar.vue?vue&type=script&lang=js&"
export * from "./ViewButtonBar.vue?vue&type=script&lang=js&"
import style0 from "./ViewButtonBar.vue?vue&type=style&index=0&id=5883b576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883b576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
